module.exports = __webpack_public_path__ + "img/shopping_list.cc2af465.png";